<template>
  <div class="pages">
    <div class="empty flex-vc" style="height:{height}px;font-size: 50px;">
      Fotoo
      <div style="margin-top: 50px;font-size: 20px;text-decoration: none;">
        <a href="http://www.pfotoo.com/">进入管理后台</a>
      </div>
    </div>
    <!--
    <router-link :to="{path:'update'}">
      <div class="add-button">添加车辆</div>
    </router-link>
    -->
    <div style="text-align: center">
      <a href="https://beian.miit.gov.cn/" style="color: rgb(87, 107, 149); padding-left: 10px; text-decoration: none;">陕ICP备18022589号-1</a>
      <div>西安空空如也网络科技有限公司®2019-2021</div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
export default {
  data () {
    return {
      cars: [],
      height:603,
    }
  },
  created(){
    this.height=window.outerHeight
    this.pathname()
  },
  methods: {
    pathname(){
      //已废弃，在静态网站托管里配置 https://console.cloud.tencent.com/tcb/hosting/index?envId=fotoo-8gcyg8ej83e3a066&rid=4&moduleName=&tabId=config
      //console.log('location.pathname',location)
      if(location.pathname){
        let url=location.origin+'/#'+location.pathname
        return location.replace(url)
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .empty{
    width: 100%;
    height: calc(100% - 50px);
    background-color: #fefefe;
  }
  .empty-icon{
    width: 191px;
    height: 159px;
    background: url("http://assets.pfotoo.com/nuoche/%E6%9A%82%E6%97%A0%E6%94%B6%E8%97%8F@2x.png");
    background-size: 100% 100%;
    margin-top: 100px;
    margin-bottom: 30px;
  }
  .empty-text{
    font-size:14px;
    font-weight:500;
    color:rgba(53,53,53,1);
  }
  .add-button{
    width:calc(100% - 100px);
    height:35px;
    background:rgba(0,151,255,1);
    border-radius:5px;
    font-size:15px;
    font-weight:500;
    color:rgba(254,254,254,1);
    line-height:35px;
    text-align: center;
    position: fixed;
    bottom: 40px;
    left:50px;
  }
  .car{
    width: calc(100% - 30px);
    margin-left: 15px;
    height:100px;
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 8px 1px rgba(224,224,224,1);
    border-radius:5px;
    margin-top: 20px;
    box-sizing: border-box;
    padding: 20px;
    font-size:16px;
    font-weight:600;
    color:rgba(53,53,53,1);
  }
  .car .ncnumber{
    margin-bottom: 13px;
    height:22px;
    line-height: 22px;
  }
  .car .ncnumber:before{
    display: inline-block;
    content: '挪车号：';
    width: 74px;
  }
  .car .mobile{
    position: relative;
  }
  .car .mobile:before{
    display: inline-block;
    content: '手机号：';
    width: 74px;
  }
  .car .mobile:after{
    display: inline-block;
    content: '未付费';
    width: 74px;
    float: right;
    background:rgba(0,151,255,1);
    color:rgba(254,254,254,1);
    border-radius:5px;
    text-align: center;
  }
  .car.payed .mobile:after{
    display: inline-block;
    content: '已付费';
    width: 74px;
    float: right;
    background:rgba(0,200,151,1);
    color:rgba(254,254,254,1);
    border-radius:5px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue